import { render, staticRenderFns } from "./documentPopUp.vue?vue&type=template&id=7a0c274b&"
import script from "./documentPopUp.vue?vue&type=script&lang=js&"
export * from "./documentPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports